import { render, staticRenderFns } from "./QuickRegister.vue?vue&type=template&id=32f1cd4d&"
import script from "./QuickRegister.vue?vue&type=script&lang=js&"
export * from "./QuickRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports